import { useGroupsOverviewListQuery } from 'core/graphql';

import { usePageVisiblePoll } from '../Meta/usePageVisiblePoll';

export interface IGroupOverview {
  groupId: string;
  name: string;
  course: string;
  startDate: string | null;
  studentsCount: number;
  debtTotal: number;
  debtCurrency: string;
  debtorsCount: number;
  unhandledStudentsCount: number;
  unreadStudentsCount: number;
  /** Total unread messages across the group's channels + members' dialogs. */
  unreadMessagesCount: number;
  openTasksCount: number;
  overdueTasksCount: number;
}

interface IUseGroupsOverview {
  groups: IGroupOverview[];
  loading: boolean;
}

/**
 * Account-manager command-center rollup (spec 0003 redesign): one row per
 * group with REAL (contribution-based) debt + unhandled/task signals.
 */
export const useGroupsOverview = (
  search?: string,
  onlyIssues?: boolean,
  pollInterval?: number,
): IUseGroupsOverview => {
  const {
    data,
    loading,
    startPolling,
    stopPolling,
  } = useGroupsOverviewListQuery({
    variables: { search: search || null, onlyIssues: Boolean(onlyIssues) },
    fetchPolicy: 'cache-and-network',
  });
  // Visibility-aware polling (spec 0008): a backgrounded tab must not keep
  // re-running the cross-group rollup.
  usePageVisiblePoll(
    startPolling,
    stopPolling,
    pollInterval || 0,
    Boolean(pollInterval),
  );
  return {
    groups: (data?.groupsOverview || []) as IGroupOverview[],
    loading,
  };
};
